import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { sectionTraversal, TWebsiteBuilderSectionTraversalUpdate } from "../../actionHelpers/sectionTraversal";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { TWebsiteBuilderDevice } from "pages/secure/facility/websiteBuilder/editor/website/shared/device";

export interface IResizeSectionActionPayload {
  id: string;
  device: TWebsiteBuilderDevice;
  prevHeight: number;
  nextHeight: number;
}

export interface IResizeSectionAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.RESIZE_SECTION;
  payload: IResizeSectionActionPayload;
}

export function getResizeSectionInverseAction(action: IResizeSectionAction): IResizeSectionAction {
  const { id, device, prevHeight, nextHeight } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.RESIZE_SECTION,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      device,
      prevHeight: nextHeight,
      nextHeight: prevHeight,
    },
  };
}

export function applyResizeSectionChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IResizeSectionAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, device, nextHeight } = action.payload;

  const update: TWebsiteBuilderSectionTraversalUpdate = prev => {
    return {
      ...prev,
      layout: {
        ...prev.layout,
        [device]: {
          ...prev.layout[device],
          height: nextHeight,
        },
      },
    };
  };

  return sectionTraversal(
    header,
    root,
    footer,
    id,
    update,
  );
}
